import React from "react";
import parse from "html-react-parser";
import { SpinnerLoading } from "../common/icons";

function Spinner({ message }) {
  return (
    <div className="spinner p-3">
      <div className="mr-2">
        <SpinnerLoading /> <span>{message}</span>
      </div>
    </div>
  );
}

export default Spinner;
